import { useState } from 'react'
import type { QueryClient } from '@tanstack/react-query'
import { MATRIX_LABELS } from '@crm/shared'
import { patchItem } from '../../../shared/api/requestItems.api'
import { patchItemInCache } from '../utils/patchItemInCache'
import { apiErrorText } from '../../../shared/api/errorText'
import { toast } from '../../../shared/ui/toastStore'

const MATRIX_OPTIONS = ['', ...MATRIX_LABELS]

export function MatrixSelect({
  itemId,
  currentMatrix,
  requestId,
  queryClient,
}: {
  itemId: string
  currentMatrix: string
  requestId: string
  queryClient: QueryClient
}) {
  const [saving, setSaving] = useState(false)

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value
    setSaving(true)
    try {
      await patchItem(itemId, { matrix: val || null })
      patchItemInCache(queryClient, requestId, itemId, { matrix: val || null })
      queryClient.invalidateQueries({ queryKey: ['requests', requestId], refetchType: 'none' })
    } catch (err) {
      // Раньше ошибка глоталась: выпадашка молча возвращала старое значение, хотя
      // при медленном диске матрица могла и сохраниться (алерт 13.10.2026 11:10).
      // Сообщаем об ошибке и перечитываем заявку — на экране то, что в базе.
      toast.error(
        apiErrorText(err, 'Не удалось сохранить матрицу. Обновите страницу и проверьте позицию.'),
      )
      void queryClient.invalidateQueries({ queryKey: ['requests', requestId] })
    } finally {
      setSaving(false)
    }
  }

  return (
    <select
      value={currentMatrix}
      onChange={handleChange}
      disabled={saving}
      className="w-full text-xs border border-gray-200 rounded px-1 py-0.5 bg-white focus:outline-none focus:ring-1 focus:ring-brand-400 disabled:opacity-50 cursor-pointer hover:border-brand-300 transition-colors"
    >
      {MATRIX_OPTIONS.map((v) => (
        <option key={v} value={v}>
          {v || '—'}
        </option>
      ))}
    </select>
  )
}
